import React, { useRef, useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Slider from "react-slick";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./CompletedProject.css";

const projectData = {
  Architecture: [
    {
      img: "/Assets/arch2.webp",
      name: "BIM Services-Sitara Hotel - Ramoji Film City",
    },
    // {
    //   img: "/Assets/arch1.webp",
    //   name: "BIM Services-Sitara Hotel - Ramoji Film City",
    // },
    {
      img: "/Assets/stra stru.webp",
      name: "BIM Services-Sitara Hotel - Ramoji Film City",
    },
  ],
  Structures: [
    {
      img: "/Assets/KADNLAKOYA.jpg",
      name: "Steel Frame Structure",
    },
    {
      img: "/Assets/kandnlakoya footing plan_page-0001.jpg",
      name: "Concrete Foundation Design",
    },
    {
      img: "/Assets/thatti annaram.jpg",
      name: "Multi-story Building Framework",
    },
  ],
  LayoutPlanning: [
    {
      img: "/Assets/layout1.webp",
      name: "Mahidhara Projects Layout Planning",
    },
    {
      img: "/Assets/layout2.webp",
      name: "Mahidhara Projects Master Plan",
    },
    {
      img: "/Assets/layout3.webp",
      name: "Mahidhara Projects Blueprint",
    },
  ],
  Interior: [
    {
      img: "/Assets/interior1.jpg",
      name: 'Luxury Living Room Design',
    },
    {
      img: "/Assets/interior2.jpg",
      name: 'Modern Kitchen Interior',
    },
    {
      img: "/Assets/interior3.jpg",
      name: 'Contemporary Bedroom Suite',
    },
    {
      img: "/Assets/interior4.jpg",
      name: 'Luxury Living Room Design Second View',
    },
    {
      img: "/Assets/interior5.jpg",
      name: 'Modern Kitchen Interior Alternate',
    },
    {
      img: "/Assets/interior6.jpg",
      name: 'Contemporary Bedroom Suite Layout',
    },
  ],
  ExteriorLandscape: [
    {
      img: "/Assets/ex1.webp",
      name: "Narapally Exterior Landscape",
    },
    {
      img: "/Assets/ex2.webp",
      name: "Narapally Landscape Design",
    },
    {
      img: "/Assets/ex3.webp",
      name: "Narapally Outdoor Space",
    },
  ],
  ApprovalDueDiligence: [
    {
      img: "/Assets/ap1.webp",
      name: "Anvaya Villas by GNR Infra Developers, Thimmapur",
    },
    {
      img: "/Assets/ap2.webp",
      name: "Anvaya Villas by GNR Infra Developers, Thimmapur",
    },
    {
      img: "/Assets/ap3.webp",
      name: "Anvaya Villas by GNR Infra Developers, Thimmapur",
    },

    {
      img: "/Assets/1ap.webp",
      name: "Vasavi Crown East, Uppal Bhagayat",
    },
    {
      img: "/Assets/2ap.webp",
      name: "Vasavi Crown East, Uppal Bhagayat",
    },
    {
      img: "/Assets/3ap.webp",
      name: "Vasavi Crown East, Uppal Bhagayat",
    },
    {
      img: "/Assets/4ap.webp",
      name: "Vasavi Crown East, Uppal Bhagayat",
    },
  ],
};

// Full category names mapping
const categoryNames = {
  Architecture: "Architecture",
  Structures: "Structures",
  LayoutPlanning: "Layout Planning",
  Interior: "Interior",
  ExteriorLandscape: "Exterior Landscape",
  ApprovalDueDiligence: "Approval Due Diligence",
};

export default function CompletedProject() {
  const [activeCategory, setActiveCategory] = useState("Architecture");
  const [loadedImages, setLoadedImages] = useState(new Set());
  const slider = useRef(null);

  // Image loading optimization
  const handleImageLoad = (imageSrc) => {
    setLoadedImages((prev) => new Set([...prev, imageSrc]));
  };

  const handleImageError = (imageSrc) => {
    console.warn(`Failed to load image: ${imageSrc}`);
  };

  // Enhanced settings with better performance and proper infinite loop
  const settings = {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: false,
    swipeToSlide: true,
    touchThreshold: 10,
    fade: false,
    cssEase: "linear",
    rtl: false,
    adaptiveHeight: false,
    centerMode: false,
    centerPadding: "0px",
    dots: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2500,
          pauseOnHover: false,
          speed: 600,
          cssEase: "linear",
          rtl: false,
          centerMode: false,
          centerPadding: "0px",
          dots: false,
        },
      },
    ],
  };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Intersection Observer for lazy loading
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "50px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute("data-src");
            observer.unobserve(img);
          }
        }
      });
    }, observerOptions);

    const images = document.querySelectorAll(".cp-slide-img[data-src]");
    images.forEach((img) => observer.observe(img));

    return () => observer.disconnect();
  }, [activeCategory]);

  // Ensure carousel properly initializes with infinite loop
  useEffect(() => {
    if (slider.current) {
      // Force reinitialization to ensure infinite loop works properly
      setTimeout(() => {
        if (slider.current) {
          slider.current.slickGoTo(0);
        }
      }, 100);
    }
  }, [activeCategory]);

  return (
    <>
      <Helmet>
        <title>Our Projects | Protek Consult - Infrastructure & Civil Engineering Portfolio</title>
        <meta name="description" content="Explore Protek Consult's completed projects in architecture, structural engineering, layout planning, interior design, and approval due diligence across Hyderabad." />
        <meta name="keywords" content="civil engineering projects Hyderabad, structural engineering portfolio, architecture projects India, layout planning projects, residential projects Hyderabad, commercial projects India, Protek Consult projects" />
        <link rel="canonical" href="https://protekconsult.com/gallery" />
        <meta property="og:title" content="Our Projects | Protek Consult - Infrastructure & Civil Engineering Portfolio" />
        <meta property="og:description" content="Explore Protek Consult's completed projects in architecture, structural engineering, and more across Hyderabad." />
        <meta property="og:url" content="https://protekconsult.com/gallery" />
      </Helmet>
    <section className="completed-project">
      {/* Header */}
      <div className="cp-header">
        <div className="cp-text">
          <h2>Project Highlights</h2>
          <p>
            From residential spaces to commercial landmarks, our completed
            projects reflect our commitment to quality, precision, and design
            excellence. Explore our portfolio to see how we’ve turned blueprints
            into lasting structures, and discover the craftsmanship behind every
            build.
          </p>
        </div>
      </div>

      {/* Body */}
      <div className="cp-body">
        {/* Sidebar */}
        <nav className="cp-sidebar">
          {Object.keys(projectData).map((cat) => (
            <button
              key={cat}
              className={`cp-cat-button${
                cat === activeCategory ? " active" : ""
              }`}
              onClick={() => {
                setActiveCategory(cat);
                slider.current.slickGoTo(0);
              }}
              aria-current={cat === activeCategory ? "true" : undefined}
            >
              {categoryNames[cat]}
              {cat === activeCategory && <FaArrowRight className="cat-arrow" />}
            </button>
          ))}
        </nav>

        {/* Carousel */}
        <div className="cp-slides">
          <button
            className="nav prev"
            onClick={() => slider.current.slickPrev()}
            aria-label="Previous slide"
            style={{ color: "#812121" }}
          >
            <FaArrowLeft style={{ color: "#812121" }} />
          </button>

          <Slider ref={slider} {...settings} className="cp-carousel">
            {projectData[activeCategory].map((item, i) => (
              <div
                className={`slide ${
                  loadedImages.has(item.img) ? "loaded" : "loading"
                }`}
                key={i}
                data-category={activeCategory}
              >
                <div className="cp-slide-box">
                  <img
                    src={item.img}
                    alt={item.name || `Project ${i + 1}`}
                    className="cp-slide-img"
                    loading="lazy"
                    onLoad={() => handleImageLoad(item.img)}
                    onError={() => handleImageError(item.img)}
                    style={{
                      opacity: loadedImages.has(item.img) ? 1 : 0,
                      transition: "opacity 0.3s ease-in-out",
                    }}
                  />
                  <div className="cp-slide-content">
                    {item.name && (
                      <h3 className="cp-slide-heading">{item.name}</h3>
                    )}
                    {item.desc && <p className="cp-slide-desc">{item.desc}</p>}
                  </div>
                </div>
              </div>
            ))}
          </Slider>

          <button
            className="nav next"
            onClick={() => slider.current.slickNext()}
            aria-label="Next slide"
            style={{ color: "#812121" }}
          >
            <FaArrowRight style={{ color: "#812121" }} />
          </button>
        </div>
      </div>
    </section>
    </>
  );
}
